import React from 'react';
import Alert from '@mui/material/Alert';
import Link from '@mui/material/Link';
import { Link as RouterLink } from 'react-router-dom';
import {
  RELEASE_STATE_LABELS,
  RELEASE_STATE_MESSAGES,
  shouldShowReleaseStateNotice,
} from './releaseState';
import { ROUTES } from './routes';

export default function ContextualEarlyAccessNotice({
  releaseState,
  message = RELEASE_STATE_MESSAGES.contextual,
  sx,
}) {
  if (!shouldShowReleaseStateNotice(releaseState)) {
    return null;
  }

  return (
    <Alert
      severity="warning"
      data-testid="contextual-early-access-notice"
      sx={{
        alignItems: 'center',
        '& .MuiAlert-message': { width: '100%' },
        ...sx,
      }}
    >
      {message}{' '}
      <Link component={RouterLink} to={ROUTES.earlyAccess} sx={{ fontWeight: 800 }}>
        {RELEASE_STATE_LABELS.learnMore}
      </Link>
    </Alert>
  );
}
